import React from 'react'

import { Checkbox, Input, } from '../../../../Shared/index'

const PROVIDERS = {
  GOOGLE: 'Google',
  CLEVER: 'Clever',
  CLASSLINK: 'ClassLink'
}

export default class UnlinkModal extends React.Component {
  constructor(props) {
    super(props)

    const { email } = this.props

    this.state = {
      email,
      password: '',
      checkboxOne: false,
      checkboxTwo: false,
      checkboxThree: false
    }
  }

  handleChange = (field, e) => {
    this.setState({ [field]: e.target.value, })
  };

  handleSubmit = e => {
    const { updateUser, provider, onUserUpdateSuccess } = this.props
    const { email, password, } = this.state
    e.preventDefault()
    const data = {
      email,
      password,
      school_options_do_not_apply: true
    };

    const providerConfigs = {
      [PROVIDERS.GOOGLE]: { google_id: null, signed_up_with_google: false },
      [PROVIDERS.CLEVER]: { clever_id: null },
      [PROVIDERS.CLASSLINK]: { unlink_classlink: true }
    };

    const providerData = providerConfigs[provider] || {};
    Object.assign(data, providerData);

    updateUser(data, '/teachers/update_my_account', `${provider} unlinked`, onUserUpdateSuccess)
  };

  getRequiredCheckboxes() {
    const { provider } = this.props;
    const checkboxRequirements = {
      [PROVIDERS.GOOGLE]: ['checkboxOne'],
      [PROVIDERS.CLEVER]: ['checkboxOne', 'checkboxTwo', 'checkboxThree'],
      [PROVIDERS.CLASSLINK]: ['checkboxOne', 'checkboxTwo', 'checkboxThree'],
    };
    return checkboxRequirements[provider] || ['checkboxOne'];
  }

  submitClass() {
    const { email, password, } = this.state
    const requiredCheckboxes = this.getRequiredCheckboxes();
    const allCheckboxesChecked = requiredCheckboxes.every(checkbox => this.state[checkbox]);

    let buttonClass = 'quill-button contained medium red focus-on-light';
    if (!(email.length && password.length && allCheckboxesChecked)) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  }

  toggleCheckbox = checkboxNumber => {
    this.setState({ [checkboxNumber]: !this.state[checkboxNumber], })
  };

  getProviderCheckboxes() {
    const { provider } = this.props;
    const checkboxConfigs = {
      [PROVIDERS.GOOGLE]: [
        { key: 'checkboxOne', text: 'I understand that I will no longer be able to sync classes with Google Classroom.' }
      ],
      [PROVIDERS.CLEVER]: [
        { key: 'checkboxOne', text: 'I understand that I no longer have access to Quill through Clever.' },
        { key: 'checkboxTwo', text: 'I understand that I now log in to Quill using the "log in" button on the homepage.' },
        { key: 'checkboxThree', text: 'I understand that my students can still access Quill through Clever.' }
      ],
      [PROVIDERS.CLASSLINK]: [
        { key: 'checkboxOne', text: 'I understand that I no longer have access to Quill through ClassLink.' },
        { key: 'checkboxTwo', text: 'I understand that I now log in to Quill using the "log in" button on the homepage.' },
        { key: 'checkboxThree', text: 'I understand that my students can still access Quill through ClassLink.' }
      ]
    };
    return checkboxConfigs[provider] || [{ key: 'checkboxOne', text: `I understand that I will no longer be able to access Quill through ${provider}.` }];
  }

  renderCheckboxes() {
    const checkboxes = this.getProviderCheckboxes();
    return (
      <div className="checkboxes">
        {checkboxes.map((checkbox) => (
          <div className="checkbox-row" key={checkbox.key}>
            <Checkbox
              id={checkbox.key}
              label={checkbox.text}
              onClick={() => this.toggleCheckbox(checkbox.key)}
              selected={!!this.state[checkbox.key]}
            />
          </div>
        ))}
      </div>
    )
  }

  render() {
    const { provider, cancel, timesSubmitted, errors, } = this.props
    const { email, password, } = this.state
    return (
      <div>
        <div className="modal-background" />
        <div className={`modal unlink-modal ${provider.toLowerCase()}`}>
          <h1>Unlink your {provider} account</h1>
          <p>
            Before we unlink your account,
            please create a password to use when logging into Quill.
          </p>
          <Input
            className="email borderless medium"
            error={errors.email}
            handleChange={(e) => this.handleChange('email', e)}
            id="change-email"
            label="Change email (optional)"
            timesSubmitted={timesSubmitted}
            type="text"
            value={email}
          />
          <Input
            className="password inspectletIgnore bordered medium"
            error={errors.password}
            handleChange={(e) => this.handleChange('password', e)}
            id="password"
            label="Password"
            timesSubmitted={timesSubmitted}
            type="password"
            value={password}
          />
          {this.renderCheckboxes()}
          <div className="button-section">
            <button className="quill-button medium outlined grey focus-on-light" id="cancel" onClick={cancel} type="button">Cancel</button>
            <input
              className={this.submitClass()}
              name="commit"
              onClick={this.handleSubmit}
              type="submit"
              value={`Unlink ${provider}`}
            />
          </div>
        </div>
      </div>
    )
  }
}
